"use client";
import { scrollFx } from "@/modules/visual/scrollFx";
import FaqAccordion from "../accordions/FAQAccordion";
import { useTranslationHomePage } from "./home.hook";

export const FAQ = () => {
  const {
    hosIsThisDifferentFromOtherChatbotTitleTranslation,
    canItDoSomethingElseAnswerTranslation,
    canItDoSomethingElseTitleTranslation,
    doesItSpeakSeveralLanguagesAnswerTranslation,
    doesItSpeakSeveralLanguagesTitleTranslation,
    doesItWorkOnAnyProductsAnswerTranslation,
    doesItWorkOnAnyProductsTitleTranslation,
    hosIsThisDifferentFromOtherChatbotAnswerTranslation,
    isItEasyToImplementAnswerTranslation,
    isItEasyToImplementTitleTranslation,
    isItGDPRCompatibleAnswerTranslation,
    isItGDPRCompatibleTitleTranslation,
    faqSectionTitleTranslation,
    canItBeCustomedAnswerTranslation,
    canItBeCustomedTitleTranslation,
  } = useTranslationHomePage();

  return (
    <section className="overflow-hidden my-12">
      <div
        className="max-w-[80%] mx-auto relative"
        {...scrollFx({ trigger: "middle", effect: "slide" })}
      >
        <div className="mb-6 flex items-center justify-center">
          <h2 className="text-3xl font-semibold tracking-tight text-zinc-900 dark:text-zinc-100 mb-6">
            {faqSectionTitleTranslation}
          </h2>
        </div>
        <FaqAccordion
          items={[
            {
              answer: hosIsThisDifferentFromOtherChatbotAnswerTranslation,
              question: hosIsThisDifferentFromOtherChatbotTitleTranslation,
            },
            {
              answer: canItDoSomethingElseAnswerTranslation,
              question: canItDoSomethingElseTitleTranslation,
            },
            {
              answer: doesItSpeakSeveralLanguagesAnswerTranslation,
              question: doesItSpeakSeveralLanguagesTitleTranslation,
            },
            {
              answer: doesItWorkOnAnyProductsAnswerTranslation,
              question: doesItWorkOnAnyProductsTitleTranslation,
            },
            {
              answer: isItGDPRCompatibleAnswerTranslation,
              question: isItGDPRCompatibleTitleTranslation,
            },
            {
              answer: canItBeCustomedAnswerTranslation,
              question: canItBeCustomedTitleTranslation,
            },
            {
              answer: isItEasyToImplementAnswerTranslation,
              question: isItEasyToImplementTitleTranslation,
            },
          ]}
        />
      </div>
    </section>
  );
};
